<template>
  <div class="list">
    <div class="itemList">
      <h1 class="topTitle">商品一覧</h1>
      <div class="container">
        <div class="outer-menu">
          <input
            class="checkbox-toggle"
            v-model="isShowSerchBox"
            type="checkbox"
          />

          <div
            class="hamburger"
            :class="{ searchIcon: !isShowSerchBox }"
            @click="isShowSerchBox = !isShowSerchBox"
          >
            <div v-if="isShowSerchBox"></div>
          </div>
          <div class="menu">
            <div class="searchArea">
              <div class="searchBox">
                <h2 class="itemTitle">検索</h2>
                <ul>
                  <li>
                    <label for="itemName">商品名:</label>
                    <input
                      type="text"
                      placeholder="商品名"
                      id="itemName"
                      v-model="serchItem.name"
                      tabindex="1"
                    />
                  </li>

                  <li class="serchDateBox">
                    <label for="price">販売価格:</label>
                    <input
                      class="searchDate"
                      type="number"
                      placeholder="販売価格（FROM）"
                      id="price"
                      v-model="serchItem.itemPriceStr"
                      tabindex="2"
                    />
                    ~
                    <input
                      class="searchDate"
                      type="number"
                      placeholder="販売価格（TO）"
                      v-model="serchItem.itemPriceEnd"
                      tabindex="2"
                    />
                  </li>
                  <li class="serchDateBox">
                    <label for="str">登録日時:</label>
                    <datepicker
                      v-model="serchItem.createDateStr"
                      format="yyyy年MM月dd日"
                      placeholder="登録日（FROM）"
                      input-class="searchDate"
                      :language="ja"
                      :disabled-dates="disabledDates"
                    ></datepicker>
                    ~
                    <datepicker
                      v-model="serchItem.createDateEnd"
                      format="yyyy年MM月dd日"
                      placeholder="登録日（TO）"
                      input-class="searchDate"
                      :language="ja"
                      :disabled-dates="disabledDates"
                    ></datepicker>
                  </li>
                </ul>
                <div class="btnBox">
                  <button
                    class="btn"
                    @click="(isShowSerchBox = !isShowSerchBox), clear()"
                  >
                    クリア
                  </button>
                  <button
                    class="btn"
                    @click="(isShowSerchBox = !isShowSerchBox), serch()"
                  >
                    検索
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="item-wrap"> -->
            <ul class="innerList">
              <li v-for="(item, index) in getItems" :key="index">
                <div class="innerBox">
                  <div class="imgWrap">
                    <a href="/shopdetail/000000031789/all_items/page1/order/"
                      ><img
                        alt="zaqa 875upk3 ブラック 男 女 ユニセックス 大容量 ハーネス スリング サスペンダー バッグ 2way ストリート アウトドア 肩掛け ショルダー"
                        :src="item.ITEM_IMG1"
                        align="middle"
                        border="0"
                        class="w-90"
                        height="80%"
                    /></a>
                  </div>
                  <div class="detail">
                    <div class="icon"></div>
                    <p class="name">
                      <img src="/images/new3.gif" /><a
                        href="/shopdetail/000000031789/all_items/page1/order/"
                        >{{item.ITEM_TITLE}}</a
                      >
                    </p>
                    <p class="price"><em class="price">1,800円（税込）</em></p>
                    <div class="else">
                        <span>zaqa875</span>
                      <ul class="clear">
                      </ul>
                    </div>
                    <p></p>
                    <div class="content">
                      注意
                      生産ロットによりバッグのファスナー開閉方向が手前から後ろ、後ろから手前また左右非対称の物がありますが異常ではありません。ご了承いただける方のご購入をお待ちしております。
                      人気のアウトドア・ストリートカジュアル
                      ファッションのアクセントになるハ...
                    </div>

                    <p class="quantity">
                      <span
                        class="M_item-stock-smallstock M_category-smallstock"
                        >残りあと25個</span
                      >
                    </p>
                    <div class="btnWrap">
                      <a href="JavaScript:basket('000000031789');"
                        ><img
                          src="https://shop61-makeshop.akamaized.net/images/original_design_default/samplesource/3/r_c_basketBtn.png"
                          alt="カートに入れる" /></a
                      ><a href="JavaScript:basket('000000031789', 'baro');"
                        ><img
                          src="https://shop61-makeshop.akamaized.net/images/original_design_default/samplesource/3/r_c_buyBtn.png"
                          alt="すぐに購入"
                      /></a>
                    </div>
                    <a href="JavaScript:login_chk('000000031789');"
                      ><img
                        src="https://shop61-makeshop.akamaized.net/images/original_design_default/samplesource/3/r_wishlistBtn.png"
                        alt="お気に入りリスト"
                    /></a>
                  </div>
                </div>
              </li>
        </ul>
          <div class="pdgTop10">
            <vuejs-paginate
              :page-count="getPaginateCount"
              :prev-text="'<'"
              :next-text="'>'"
              :click-handler="paginateClickCallback"
              :container-class="'pagination justify-content-center'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'"
              :first-last-button="true"
              :first-button-text="'<<'"
              :last-button-text="'>>'"
              :force-page="currentPage"
            ></vuejs-paginate>
          </div>
        </div>
        <div class="btnBox subArea">
          <!-- <button class="btn repage" @click="returnPage">戻る</button>
                <button class="btn submit" @click="newRegister" >商品登録</button> -->
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>
<script>
import { itemRepository } from "@/Repositories/itemRepository.js";
import VueJsPaginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import check from "@/common/commonCheck";
import {
  required,
  maxLength,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      /******************
       * Datepicker設定
       ******************/
      ja: ja,

      disabledDates: {
        from: new Date(),
      },

      isShowSerchBox: false,
      itemList: [],
      tmpItemList: [],
      tmp: "",
      serchItem: {
        name: null,
        itemPrice: null,
        createDateStr: null,
        createDateEnd: null,
      },
      currentPage: 1,
      perPage: 20,
    };
  },
  components: {
    "vuejs-paginate": VueJsPaginate,
    Datepicker,
  },
  methods: {
    serch() {
      let vm = this;
      var tmpItemList = [...vm.itemList];
      if (vm.serchItem.name) {
        //名前フィルター
        tmpItemList = tmpItemList.filter(function (item) {
          return item.ITEM_TITLE.match(vm.serchItem.name) != null;
        });
      }
      if (vm.serchItem.itemPriceStr) {
        //存在チェック
        tmpItemList = tmpItemList.filter(function (item) {
          return Number(item.ITEM_PRICE) >= Number(vm.serchItem.itemPriceStr);
        });
      }
      if (vm.serchItem.itemPriceEnd) {
        //存在チェック
        tmpItemList = tmpItemList.filter(function (item) {
          return Number(item.ITEM_PRICE) <= Number(vm.serchItem.itemPriceEnd);
        });
      }
      if (vm.serchItem.createDateStr) {
        //存在チェック
        var str = moment(vm.serchItem.createDateStr).format("YYYYMMDD");
        tmpItemList = tmpItemList.filter(function (item) {
          return Number(item.CREATE_DAY) >= Number(str);
        });
      }
      if (vm.serchItem.createDateEnd) {
        //存在チェック
        var end = moment(vm.serchItem.createDateEnd).format("YYYYMMDD");
        tmpItemList = tmpItemList.filter(function (item) {
          return Number(item.CREATE_DAY) <= Number(end);
        });
      }
      vm.tmpItemList = tmpItemList;
    },
    clear() {
      this.tmpItemList = [...this.itemList];
      this.serchItem = {};
    },
    paginateClickCallback(pageNum) {
      this.currentPage = Number(pageNum);
    },
    returnPage() {
      let vm = this;
      vm.$router.back();
    },
  },
  computed: {
    getPaginateCount: function () {
      return Math.ceil(this.tmpItemList.length / this.perPage);
    },
    getItems() {
      if (this.itemList.length == 0) return;
      let start = (this.currentPage - 1) * this.perPage;
      let end = this.currentPage * this.perPage;
      return this.tmpItemList.slice(start, end);
    },
  },
  created: function () {
    let vm = this;
    var pageNum = vm.$route.params.pageNum;
    if (!pageNum) pageNum = 1;
    itemRepository.methods
      .getPage()
      .then((res) => {
        vm.itemList = res.data;
        vm.tmpItemList = res.data;
        vm.paginateClickCallback(pageNum);
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss">
.innerList {
  overflow: hidden;
  letter-spacing: -0.4em;
  text-align: left;
  
}
.innerList li {
    vertical-align: top;
    letter-spacing: normal;
    width: 25%;
    display: inline-block;
    padding: 5px;
    
    padding-bottom: 20px;
    // display: table-cell;
}
.imgWrap {
  text-align: center;
  margin-bottom: 5px;
}
a:link {
  color: #1049a0;
  text-decoration: underline;
}
img {
  vertical-align: middle;
}
.name {
  margin-bottom: 5px;
}
.price {
  font-weight: bold;
  color: #333;
}
.else {
  text-align: left;
}
.clear:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.content {
  border-top: 1px dashed #b2b2b2;
  padding: 10px 0;
  margin: 10px auto;
  border-bottom: 1px dashed #b2b2b2;
  font-size: 11px;
}
.btnWrap {
  margin: 10px auto 5px;
  background: #e6e6e6;
  padding: 5px 0;
  text-align: left;
}
.w-90{
    width: 90%;
}
</style>    